import { Box } from "@mui/material";
import { ReactNode } from "react";

interface IProps {
  children: ReactNode;
}

const CharacteristicCard: React.FC<IProps> = ({ children }) => {
  return (
    <Box
      bgcolor="background.default"
      px={{ xs: 2, md: 8, lg: 11, xl: 12.5 }}
      pt={{ xs: 2, md: 8, lg: 11, xl: 12.5 }}
      pb={{ xs: 3, md: 8, lg: 11, xl: 12.5 }}
      borderRadius={5}
      mt={{ xs: 3, md: 5 }}
    >
      {children}
    </Box>
  );
};

export default CharacteristicCard;
